module.exports = __webpack_public_path__ + "img/yin.3ff5df1d.png";